jQuery(document).ready(function () {
    var $og_url_meta = jQuery( 'meta[property="og:url"]' );
    if ( jQuery( 'meta[property="og:url"]' ).length > 0 ) {
        var meta_content = $og_url_meta.prop( 'content' );

        console.log( meta_content );
        console.log( 'REMOVING' );

        meta_content = meta_content.replace( '/en/en/', '/en/' );

        console.log( meta_content );
        //$og_url_meta.remove();

        $og_url_meta.each( function () {
            jQuery( this ).prop( 'content', meta_content ).attr( 'content', meta_content );
        });


        //$('head').append( '<meta property="og:url" content="' + meta_content + '">' );

    }

    setTimeout( function() {
        jQuery( '.wishlist-hero-custom-button' ).each( function () {
            if ( jQuery( this ).find( '[title="Remove from wishlist"]' ).length > 0 ) {
                jQuery( this ).next( '.fake-wl-icon' ).toggleClass( 'active' );
            }
        });
    }, 1000 );

    jQuery( '.wishlist-hero-custom-button' ).on( 'click', function ( evt ) {
        jQuery( this ).next( '.fake-wl-icon' ).toggleClass( 'active' );
    });
});

// Fixing English Wishlist Share URL having duplicate language codes
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        console.log(mutation)
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
            // element added to DOM
            var hasClass = [].some.call(mutation.addedNodes, function(el) {
                return el.classList.contains( 'MuiDialog-root' )
            });
            if ( hasClass ) {
                // check if dialog contains a share link
                if ( jQuery( '.wishlist-hero-share-link' ).length > 0 ) {
                    var $share_link_field = jQuery( '.wishlist-hero-share-link input' ),
                        share_link = $share_link_field.val();

                    share_link = share_link.replace( '/en/en/', '/en/' );
                    console.log(share_link);
                    $share_link_field.val( share_link ).attr( 'value', share_link ).prop( 'value', share_link );
                }
            }
        }
    });
});

var config = {
    attributes: true,
    childList: true,
    characterData: true
};

observer.observe(document.body, config);